import React, { FC } from 'react'
import { i18n } from 'LibNeo/utils/intl'
import { Label } from 'LibNeo/components/Basic/Label/Label/styled'

interface LabelProps {
	title: string
}

export const LabelComponent: FC<LabelProps> = ({ title }) => {
	return <Label>{i18n(title)}</Label>
}
